var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full home"},[_c('navbar-component'),_c('call-to-action-component'),_c('my-reserve-card-component'),_c('our-centers-component'),_c('bottom-bar-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }